class VolumeInput {
    towerId: number;
    towerName:string;
    roleId: number;
    roleName:string;
    spend:number;
    inputs:any[];
}

export default VolumeInput;